import { GetCurrencySymbol } from '../../../../../utils/Currency';
import { GetFloatNumber } from '../../../../../utils/NumberFormatter';

function Info({ title, value }) {
    return (
        <div className="flex items-center gap-x-4">
            <div className="w-[100px]">
                <p className="text-primary-700">{title}</p>
            </div>
            :
            <div className="w-[calc(100%_-_140px)]">
                <p className="text-primary">
                    <span> {value}</span>
                </p>
            </div>
        </div>
    );
}

function InvoiceInfoRow({ invoiceData, billingAddress }) {
    const { id, amountBilled, amountPaid, amountDue, currency, demo } = invoiceData || {};
    const { address, city, country } = billingAddress || {};

    return (
        <div className={`min-h-72 ${demo ? 'placeholder-mode' : ''}`}>
            <div className="mb-4">
                <h2 className="text-primary text-xl font-normal">Invoice Info</h2>
            </div>
            <div className="flex flex-col gap-y-2 border-b border-primary-50 pb-2 mb-2">
                <Info title="Invoice Id" value={id} />
                {/* <Info title="Currency" value={currency || 'USD'} /> */}
                <Info
                    title="Billed Amount"
                    value={`${GetCurrencySymbol(currency)}${GetFloatNumber(amountBilled)}`}
                />
                <Info
                    title="Paid Amount"
                    value={`${GetCurrencySymbol(currency)}${GetFloatNumber(amountPaid)}`}
                />
                <Info
                    title="Current Due"
                    value={`${GetCurrencySymbol(currency)}${GetFloatNumber(amountDue)}`}
                />
            </div>

            <div className="flex flex-col gap-y-2">
                <div className="flex items-start gap-x-4">
                    <div className="w-[100px]">
                        <p className="text-primary-700">Address</p>
                    </div>
                    :
                    <div className="w-[calc(100%_-_140px)]">
                        <p className="text-primary">
                            <span>
                                {[address, city, country].filter((d) => !!d).join(', ') ||
                                    '----------------------'}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InvoiceInfoRow;
